<template>
   <div id="ancillaries-container">
      <AncillariesModal :settings="settings" v-if="ancillariesModalStatus && !hideModalPopup" :orderId="pnr.orderId" :pnrId="pnr.id" />
      <SeatMapModal :currency="currency" :pnrId="pnr.id" v-if="SeatMapModalStatus" />
      <span class="ancillaries-header">{{ $t("ancillariesServices_title") }}</span>
      <div class="ancillaries-buttons-wrapper-v">
         <ul>
            <template v-for="(ancillary, key) in ancillaries">
               <li :key="key" @click="handlerTrigger(key)" :class="{ 'is-disabled': !ancillary.enabled }">
                  <div class="ancillary-box-wrapper">
                     <div class="ancillary-box-icon-wrapper">
                        <i class="gts-icon" :class="mode === 'Dark' ? ancillary.iconDark : ancillary.iconLight"></i>
                     </div>
                     <div class="ancillary-box-info-wrapper">
                        <div>
                           <span class="ancillary-title">{{ ancillary.name }} </span>
                           <p class="ancillary-description" v-if="ancillary.showDescription">
                              {{ ancillary.description }}
                           </p>
                        </div>
                        <div class="ancillary-add-btn-wrapper" :class="{ invisible: !ancillary.enabled }">
                           <UIButton className="default" :text="$t('common_add')" :isSpinnerActive="ancillary.isLoading" />
                        </div>
                     </div>
                  </div>
               </li>
            </template>
         </ul>

         <!-- CSS düzenini korumak için bu div'i tekrar ekliyoruz -->
         <div id="ancillaries-informations">
            <p v-html="handlerRelatedPnrInfosFMT(pnr.pnr)"></p>
            <p>{{ $t("ancillariesServices_relatedPPaymentMethods") }}</p>
         </div>
      </div>
   </div>
</template>

<script>
import { flightModelGenerator } from "@/components/structural/flight/order-detail/ancillaries/helpers/ancillary-reissue.js";
import { generateUuid } from "@/utils.js";
import { flightService } from "@/service/index.js";
import { objectify } from "@/helper/common.js";
// import { GeneratedJSON } from "@/components/seatMap/SeatMapData.js";
import AncillariesModal from "@/components/structural/flight/order-detail/ancillaries/base/AncillariesModal.vue";
import SeatMapModal from "@/components/structural/flight/order-detail/ancillaries/seatmap2/SeatMapModal.vue";
// import Popup from "@/gts-popup.js";
import UIButton from "@/components/unitary/Button.vue";
import { ancillariesListFunction } from "@/helper/ancillariesList.js";
// import { res_validate } from "@/components/widgets/helpers/dummyReissue.js";
export default {
   name: "Ancillaries",
   props: {
      pnr: Object,
      onlineCheckInUrl: String,
      ancillaryChoices: Object,
      passengers: Array,
      currency: String,
      offerTrigger: String,
      hideModalPopup: Boolean,
   },
   components: {
      AncillariesModal,
      SeatMapModal,
      UIButton,
   },
   data() {
      return {
         ancillariesModalStatus: false,
         mode: "Light",

         settings: {
            //buraya bakılacak
            searchUuid: null,
            // buraya bakılacak ends
            type: null, //bagaj //Divide
            steps: [],
            paxes: [],
            flights: [],
            meals: [],
            ssrs: [],
            wheelchair: [],
            refund: {},
            availableType: Number,
            seats: [],
            pnrHasAncillaries: false,
         },
         ancillaries: ancillariesListFunction(this.ancillaryChoices),
      };
   },

   mounted() {
      const htmlElement = document.documentElement;
      if (htmlElement.classList.contains("dark-theme")) {
         this.mode = "Dark";
      }
   },
   computed: {
      SeatMapModalStatus() {
         const idControl = this.pnr.id == this.$store.state.seatmap.pnr.id;
         return this.$store.state.seatmap.pnr.status && idControl;
      },
      SomeAncillaryIsLoading() {
         return Object.keys(this.ancillaries).some((a) => {
            return this.ancillaries[a].isLoading;
         });
      },
   },
   methods: {
      handlerTrigger(key) {
         if (this.ancillaries[key].enabled && !this.SomeAncillaryIsLoading) {
            switch (key) {
               case "baggage":
                  this.handlerAncillaryBaggage();

                  break;
               case "divide":
                  this.handlerAncillaryDivide();
                  break;
               case "reissue":
                  this.handlerAncillaryReissue();
                  break;
               case "seat":
                  this.handlerAncillarySeat();
                  break;
               case "wheelchair":
                  this.handlerAncillaryWheelChair();
                  break;
               case "meal":
                  this.handlerAncillarySearchMeal();
                  break;
               case "onlineCheckin":
                  var onlineCheckInUrl = this.ancillaryChoices.onlineCheckinUrl;
                  window.open(onlineCheckInUrl, "_blank");
                  break;
               case "ssr":
                  this.handlerSSRs();
                  break;
               case "refund":
                  this.handlerRefund();

                  break;
               default:
            }
         }
      },
      handlerRefund() {
         let request = {
            uuid: sessionStorage.getItem(this.pnr.id),
            orderUuid: this.$store.state.order.orderUuid,
            pnrId: this.pnr.id,
         };
         this.ancillaries.refund.isLoading = true;
         flightService
            .flightReverseInquiry(request)
            .then((response) => {
               this.$store.commit("flight/setErrorId", response.errorId);
               this.$store.commit("flight/setErrorType", { type: 1, errorMsg: `RESPONSE_${response.result.app}_${response.result.service}_${response.result.code}_${response.result.subCode}` });

               if (response.result.success) {
                  this.settings.refund = response;
                  this.ancillariesModalStatus = true;
               }
            })
            .finally(() => {
               this.handlerAncillarySettings(10);
               this.ancillaries.refund.isLoading = false;
               this.$store.commit("app/setIsProgressGifActive", false);
            });
      },

      handlerAncillarySettings(type) {
         this.settings.type = type;

         if (type == 1) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepSelectBaggage" }, { name: "ancillariesServicesModal_stepPayment" }, { name: "ancillariesServicesModal_stepResult" }];
         }
         if (type == 5) {
            this.settings.steps = [
               { name: "ancillariesServicesModal_stepFlightSelection" },
               { name: "ancillariesServicesModal_stepFlightSearchResult" },
               { name: "ancillariesServicesModal_stepReissuePayment" },
               { name: "ancillariesServicesModal_stepReissueResult" },
            ];
         }
         if (type == 3) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepDivide" }, { name: "ancillariesServicesModal_stepResult" }];
         }
         if (type == 6) {
            this.settings.steps = [{ name: "Seat Selection" }, { name: "ancillariesServicesModal_stepResult" }];
         }
         if (type == 7) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepWheelChairSelection" }, { name: "ancillariesServicesModal_stepResult" }];
         }
         if (type == 8) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepMealSelection" }, { name: "ancillariesServicesModal_stepReissuePayment" }, { name: "ancillariesServicesModal_stepResult" }];
         }
         if (type == 9) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepSssr" }, { name: "ancillariesServicesModal_stepResult" }];
         }
         if (type == 10) {
            this.settings.steps = [{ name: "ancillariesServicesModal_stepRefund" }, { name: "ancillariesServicesModal_stepResult" }];
         }
      },

      handlerSSRs() {
         this.ancillaries.ssr.isLoading = true;
         const query = {
            uuid: generateUuid(),
            pnrId: this.pnr.id,
         };
         sessionStorage.setItem("constantUuid", query.uuid);

         flightService
            .ancillarySearchSsrs(query)
            .then((response) => {
               this.$store.commit("flight/setErrorId", response.errorId);
               this.$store.commit("flight/setErrorType", { type: 3, errorMsg: `RESPONSE_${response.result.app}_${response.result.service}_${response.result.code}_${response.result.subCode}` });

               if (response.result.success) {
                  this.$store.state.order.searchUuid = response.searchUuid;
                  this.settings.searchUuid = response.searchUuid;
                  this.settings.ssrs = response.paxes.map((pax) => {
                     return {
                        paxNumber: pax.index,
                        paxId: pax.id,
                        name: `${pax.name} ${pax.surname}`,
                        paxType: this.$options.filters.EFltPaxType(pax.paxType),
                        segments: response.segments.map((segment) => {
                           const paxIndex = pax.index;
                           const offerKey = `${segment.flightIndex}_${segment.segmentIndex}`;
                           return {
                              segmentId: segment.segmentId,
                              segmentIndex: segment.segmentIndex,
                              from: segment.departureAirport,
                              to: segment.arrivalAirport,
                              marketingAirlineCode: segment.operatingAirline,
                              flightCode: segment.flightId,
                              departureDate: segment.departureDateTime,
                              ssrs: {
                                 ssr: {
                                    hasSelection: response.bookedSsrs[paxIndex][offerKey] ? this.$options.filters.EFltSsrType(response.bookedSsrs[paxIndex][offerKey]) : false,
                                    // hasSelection: response.bookedSsrs[paxIndex][offerKey] ? response.bookedSsrs[paxIndex][offerKey] : false,
                                    items: response.ssrOffers[paxIndex][offerKey].map((item) => {
                                       return {
                                          name: this.$i18n.t("ancillariesServicesModal_lblSSR"),
                                          description: this.$i18n.t("ancillariesServicesModal_lblSSRDesc"),
                                          // description: "maya",
                                          identifier: item.identifier,
                                          price: item.price,
                                          currency: item.currency,
                                          selected: false,
                                          value: {
                                             paxIndex: paxIndex,
                                             segment: `${segment.flightIndex}_${segment.segmentIndex}`,
                                             type: item,
                                          },
                                       };
                                    }),
                                 },
                              },
                           };
                        }),
                     };
                  });

                  this.ancillariesModalStatus = true;
                  this.ancillaries.ssr.isLoading = false;
               } else {
                  this.ancillaries.ssr.isLoading = false;
                  // Popup.warning(this.$i18n.t("Popup_lblEmptySearch"), this.$i18n.t("Popup_txtSsrsNotAvailable"), undefined, 10000);
               }
               this.handlerAncillarySettings(9);
            })
            .finally(() => {
               this.ancillaries.ssr.isLoading = false;
            });
      },

      handlerAncillaryDivide() {
         this.ancillaries.divide.isLoading = true;
         // Passenger Data to Array End
         const passengerArray = [];
         this.passengers.map((item) => {
            const rowObj = {
               name: item.passenger.name,
               surname: item.passenger.surname,
               type: item.passenger.type,
               id: item.passenger.id,
               paxIndex: item.passenger.paxIndex,
               parentIndex: item.passenger.parentIndex,
            };
            passengerArray.push(rowObj);
         });
         this.settings.paxes = passengerArray;

         this.handlerAncillarySettings(3);
         this.ancillariesModalStatus = true;
      },

      handlerAncillaryBaggage() {
         this.handlerAncillarySettings(1);
         this.ancillaries.baggage.isLoading = true;

         const query = {
            uuid: generateUuid(),
            pnrId: this.pnr.id,
         };

         sessionStorage.setItem("constantUuid", query.uuid);

         flightService.ancillaryBaggages(query).then((res) => {
            this.$store.commit("flight/setErrorId", res.errorId);
            this.$store.commit("flight/setErrorType", { type: 3, errorMsg: `RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}` });
            if (res.result.success) {
               this.$store.state.order.searchUuid = res.searchUuid;
               this.generatorAncillaryBaggageModel(res);
            } else {
               this.ancillaries.baggage.isLoading = false;
               // this.ancillariesModalStatus = true;
               // const title = this.$t(`RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}_TITLE`);
               // const subTitle = this.$t(`RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}`);
               // Popup.info(title, subTitle);
            }
         });
      },

      handlerAncillaryReissue() {
         this.handlerAncillarySettings(5);
         this.ancillaries.reissue.isLoading = true;

         const reissueUuid = generateUuid();

         sessionStorage.setItem("reissueUuid", reissueUuid);

         const query = {
            uuid: sessionStorage.getItem("reissueUuid"),
            pnrId: this.pnr.id,
         };

         flightService.ancillaryReissueValidate(query).then((res) => {
            this.$store.commit("flight/setErrorId", res.errorId);
            this.$store.commit("flight/setErrorType", { type: 2, errorMsg: `RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}` });
            if (res.result.success) {
               this.settings.availableType = res.availableType;
               this.settings.flights = flightModelGenerator(res.flights);
               this.ancillariesModalStatus = true;
            } else {
               // const title = this.$t(`RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}_TITLE`);
               // const subTitle = this.$t(`RESPONSE_${res.result.app}_${res.result.service}_${res.result.code}_${res.result.subCode}`);
               // Popup.info(title, subTitle);
            }
            setTimeout(() => {
               this.ancillaries.reissue.isLoading = false;
            }, 1000);
         });
      },

      handlerAncillarySeat() {
         this.$store.commit("seatmap/setStatus", { status: true, id: this.pnr.id });
      },

      handlerAncillaryWheelChair() {
         this.ancillaries.wheelchair.isLoading = true;
         const query = {
            uuid: generateUuid(),
            pnrId: this.pnr.id,
         };

         sessionStorage.setItem("constantUuid", query.uuid);

         flightService.ancillarySearchWheelChair(query).then((response) => {
            this.$store.commit("flight/setErrorId", response.errorId);
            this.$store.commit("flight/setErrorType", { type: 3, errorMsg: `RESPONSE_${response.result.app}_${response.result.service}_${response.result.code}_${response.result.subCode}` });
            if (response.result.success) {
               this.settings.searchUuid = response.searchUuid;
               this.settings.wheelchair = response.paxes.map((pax) => {
                  return {
                     paxNumber: pax.index,
                     paxId: pax.id,
                     name: `${pax.name} ${pax.surname}`,
                     paxType: this.$options.filters.EFltPaxType(pax.paxType),
                     segments: response.segments.map((segment) => {
                        const paxIndex = pax.index;
                        const offerKey = `${segment.flightIndex}_${segment.segmentIndex}`;

                        return {
                           segmentId: segment.segmentId,
                           segmentIndex: segment.segmentIndex,
                           from: segment.departureAirport,
                           to: segment.arrivalAirport,
                           marketingAirlineCode: segment.operatingAirline,
                           flightCode: segment.flightId,
                           departureDate: segment.departureDateTime,
                           ssrs: {
                              wheelchair: {
                                 hasSelection: response.bookedWheelChairs[paxIndex][offerKey] ? this.$options.filters.EFltSsrWheelchairTypeEnum(response.bookedWheelChairs[paxIndex][offerKey]) : false,

                                 items: response.wheelChairOffers[paxIndex][offerKey].map((item) => {
                                    return {
                                       // name: this.$options.filters.EFltSsrWheelchairTypeEnum(item.type),
                                       name: item.type,
                                       // description: this.$options.filters.EFltSsrWheelchairType(item.type),
                                       description: this.$i18n.t("EFltSsrWheelchairType_" + item.type),
                                       identifier: item.identifier,
                                       value: {
                                          paxIndex: paxIndex,
                                          segment: `${segment.flightIndex}_${segment.segmentIndex}`,
                                          type: item,
                                       },
                                    };
                                 }),
                              },
                           },
                        };
                     }),
                  };
               });

               this.ancillariesModalStatus = true;
               this.ancillaries.wheelchair.isLoading = false;
            } else {
               this.ancillaries.wheelchair.isLoading = false;
               // Popup.warning(this.$i18n.t("Popup_lblEmptySearch"), this.$i18n.t("Popup_txtWheelChairNotAvailable"), undefined, 10000);
            }
         });

         this.handlerAncillarySettings(7);
      },

      handlerAncillarySearchMeal() {
         this.ancillaries.meal.isLoading = true;
         const query = {
            uuid: generateUuid(),
            pnrId: this.pnr.id,
         };
         sessionStorage.setItem("constantUuid", query.uuid);
         flightService.ancillarySearchMeal(query).then((response) => {
            this.$store.commit("flight/setErrorId", response.errorId);
            this.$store.commit("flight/setErrorType", { type: 3, errorMsg: `RESPONSE_${response.result.app}_${response.result.service}_${response.result.code}_${response.result.subCode}` });
            if (response.result.success) {
               this.$store.state.order.searchUuid = response.searchUuid;
               this.settings.searchUuid = response.searchUuid;
               this.settings.meals = response.paxes.map((pax) => {
                  return {
                     paxNumber: pax.index,
                     paxId: pax.id,
                     name: `${pax.name} ${pax.surname}`,
                     paxType: this.$options.filters.EFltPaxType(pax.paxType),
                     segments: response.segments.map((segment) => {
                        const paxIndex = pax.index;
                        const offerKey = `${segment.flightIndex}_${segment.segmentIndex}`;
                        return {
                           segmentId: segment.segmentId,
                           segmentIndex: segment.segmentIndex,
                           from: segment.departureAirport,
                           to: segment.arrivalAirport,
                           marketingAirlineCode: segment.operatingAirline,
                           flightCode: segment.flightId,
                           departureDate: segment.departureDateTime,
                           ssrs: {
                              food: {
                                 hasSelection: response.bookedMeals[paxIndex][offerKey] ? this.$options.filters.EFltSsrMealTypeEnum(response.bookedMeals[paxIndex][offerKey]) : false,
                                 items: response.mealOffers[paxIndex][offerKey].map((item) => {
                                    return {
                                       // name: this.$options.filters.EFltSsrMealType(item.type),

                                       name: this.$i18n.t("EFltSsrMealType_" + item.type),
                                       description: this.$i18n.t("EFltSsrMealTypeEnum_" + item.type),
                                       identifier: item.identifier,
                                       price: item.price,
                                       currency: item.currency,
                                       selected: false,
                                       value: {
                                          paxIndex: paxIndex,
                                          segment: `${segment.flightIndex}_${segment.segmentIndex}`,
                                          type: item,
                                       },
                                    };
                                 }),
                              },
                           },
                        };
                     }),
                  };
               });

               this.ancillariesModalStatus = true;
               this.ancillaries.meal.isLoading = false;
            } else {
               this.ancillaries.meal.isLoading = false;
               // this.ancillariesModalStatus = true;
               // Popup.warning(this.$i18n.t("Popup_lblEmptySearch"), this.$i18n.t("Popup_txtMealNotAvailable"), undefined, 10000);
            }
            this.handlerAncillarySettings(8);
         });
      },

      generatorAncillaryBaggageModel(obj) {
         this.settings.paxes = [];
         const genExBaggageSelector = function (objOffers) {
            const selectorArr = [{ name: "Ext. Baggage", value: 0 }];

            if (objOffers != undefined) {
               objOffers.forEach((offer) => {
                  const rowObj = {
                     name: `${obj.baggageOffers[offer].info} - ${obj.baggageOffers[offer].price} ${obj.baggageOffers[offer].currency} `,
                     value: obj.baggageOffers[offer].price,
                     hidden: obj.baggageOffers[offer].key,
                  };
                  selectorArr.push(rowObj);
               });
            }
            return selectorArr;
         };

         //Creating Flight Obj
         const flights = objectify(obj.flights, (f) => f.flightId);

         // Each Pax Loop
         obj.paxes.forEach((pax, index) => {
            const rowObj = {
               name: `${pax.name} ${pax.surname}`,
               paxType: pax.paxType,
               paxId: pax.paxId,
               paxIndex: index + 1,
               flights: {},
            };

            // Each Flight Loop
            Object.keys(pax.baggages).forEach((baggage, baggageIndex) => {
               rowObj.flights[baggageIndex] = {
                  from: flights[baggage].fromAirportCode,
                  to: flights[baggage].toAirportCode,
                  flightId: flights[baggage].flightId,
                  airlineCode: flights[baggage].marketingAirlineCode,
                  baggage: pax.baggages[baggage].baggage + "KG",
                  baggageSelection: 0,
                  extraBaggage: genExBaggageSelector(pax.baggageOffers[baggage]),
               };
            });
            this.settings.paxes.push(rowObj);
         });
         const self = this;
         setTimeout(() => {
            self.ancillariesModalStatus = true;
         }, 1000);
      },

      handlerRelatedPnrInfosFMT(pnr) {
         return this.$t("ancillariesServices_relatedPNRInfos").replace("{PNR}", `<b>${pnr}</b>`);
      },
   },
   watch: {
      SeatMapModalStatus: {
         handler: function (status) {
            this.$store.state.flight.ancillariesPopUp = status;

            if (this.$store.state.app.modalViewStatus.status) {
               this.$store.state.seatmap.pnr.status = false;
               return;
            }
            // let automatedCPopup;

            if (!status) {
               window.location.reload();
               // this.$nextTick(() => {
               //    automatedCPopup = document.getElementById("ancillaries-automated-c");
               // });
            }
         },
      },
      ancillariesModalStatus: {
         handler: function (status) {
            this.$store.commit("app/setIsProgressGifActive", false);
            this.$store.state.flight.ancillariesPopUp = status;
         },
      },
      offerTrigger: {
         handler: function (key) {
            if (key.length != 0) {
               this.handlerTrigger(key);
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
#ancillaries-container {
   .ancillaries-header {
      font-size: var(--large);
      font-weight: 600;
      margin-bottom: 1.5rem !important;
      display: block;
   }
   .ancillaries-buttons-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      ul {
         display: flex;
         flex-wrap: wrap;

         li {
            width: 33%;
            @media (max-width: 992px) {
               width: 100%;
            }

            &.is-disabled {
               opacity: 0.3;
               filter: grayscale(100%);

               .ancillary-box-wrapper {
                  cursor: not-allowed;
                  box-shadow: none;
                  outline: 4px solid var(--gray-300);

                  &:hover {
                     background-color: transparent;
                     outline: 1.5px solid var(--gray-200);
                  }
               }
            }

            .ancillary-box-wrapper {
               display: flex;
               outline: 3px solid var(--gray-200);
               border-radius: 1rem;
               padding: 1rem 1.5rem;
               margin: 1rem;
               cursor: pointer;
               /* box-shadow: var(--gray-1000-alpha-75) 0px 4px 6px -1px, var(--gray-1000-alpha-75) 0px 2px 4px -1px; */
               box-shadow: var(--gts-box-shadow);

               &:hover {
                  //background-color: var(--gray-50);
                  background-color: var(--gray-0);
                  outline-color: var(--orange-400);

                  .ancillary-box-icon-wrapper {
                     i {
                        transform: scale(1.1) rotate(-2.5deg);
                     }
                  }
               }

               .ancillary-box-icon-wrapper {
                  width: 132px;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-shrink: 0;

                  i {
                     width: 100px !important;
                     height: 100px !important;
                     transition: all 0.15s ease-in-out;
                     &.icon-ancillary-c-baggage {
                        width: 110px !important;
                        height: 120px !important;
                        margin-left: -10px;
                     }
                     &.icon-ancillary-c-checkin {
                        width: 118px !important;
                        height: 98px !important;
                        margin-top: -5px;
                     }
                     &.icon-ancillary-c-divide {
                        width: 120px !important;
                        height: 140px !important;
                        margin-left: -25px;
                        margin-top: 10px;
                     }
                     &.icon-ancillary-c-reissue {
                        width: 120px !important;
                        height: 105px !important;
                     }
                     &.icon-ancillary-c-seat {
                        width: 100px !important;
                        height: 105px !important;
                        margin-left: -10px;
                     }
                     &.icon-ancillary-c-wheelchair {
                        width: 100px !important;
                        height: 95px !important;
                        margin-left: -20px;
                     }
                     &.icon-ancillary-c-meal {
                        width: 120px !important;
                        height: 120px !important;
                        margin-left: -20px;
                     }
                     &.icon-ancillary-c-sunflex3 {
                        width: 180px !important;
                        height: 180px !important;
                        margin-left: 0;
                     }
                  }
               }

               .ancillary-box-info-wrapper {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  width: 100%;
                  .ancillary-title {
                     font-size: 1.125rem;
                     font-weight: 500;
                  }
                  .ancillary-description {
                     opacity: 0.85;

                     width: 100px !important;
                  }
                  .ancillary-add-btn-wrapper {
                     display: flex;
                     justify-content: flex-end;

                     button {
                        background-color: var(--gray-800);
                        background-color: var(--orange-400);
                        //color: var(--gray-50);
                        color: var(--gray-0);
                        padding: 0.125rem 1.5rem;
                        border-radius: 8px;
                        font-weight: 600 !important;

                        &:hover {
                           background-color: var(--accent-primary);
                           background-color: var(--gray-800);
                        }
                     }
                  }
               }
            }
         }
      }
   }
   .ancillaries-buttons-wrapper-v {
      display: flex;
      flex-direction: column;
      align-items: center;

      ul {
         display: flex;
         flex-wrap: wrap;
         @media (max-width: 576px) {
            justify-content: center;
         }
         li {
            min-width: 20%;

            &.is-disabled {
               opacity: 0.3;
               filter: grayscale(100%);

               .ancillary-box-wrapper {
                  cursor: not-allowed;
                  box-shadow: none;
                  outline: 4px solid var(--gray-300);

                  &:hover {
                     background-color: transparent;
                     outline: 1.5px solid var(--gray-200);

                     .ancillary-box-icon-wrapper {
                        i {
                           transform: none !important;
                        }
                     }
                  }
               }
            }

            .ancillary-box-wrapper {
               display: flex;
               flex-direction: column;
               align-items: center;
               outline: 3px solid var(--gray-200);
               border-radius: 1rem;
               padding: 1rem 1.5rem;
               margin: 1rem;
               background-color: var(--surface-level-1);

               &:hover {
                  //background-color: var(--gray-50);
                  background-color: var(--gray-0);
                  outline-color: var(--orange-400);

                  .ancillary-box-icon-wrapper {
                     i {
                        transform: scale(0.85) rotate(-2.5deg);
                     }
                  }
               }
               .ancillary-box-icon-wrapper {
                  width: 132px;
                  height: 100px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-shrink: 0;

                  i {
                     width: 100px !important;
                     height: 100px !important;
                     transition: all 0.15s ease-in-out;
                     transform: scale(0.75);
                     filter: none !important;
                     &.icon-ancillary-c-baggage {
                        width: 110px !important;
                        height: 120px !important;
                        margin-left: -10px;
                     }
                     &.icon-ancillary-c-onlineCheckin {
                        width: 118px !important;
                        height: 98px !important;
                        margin-top: -5px;
                     }
                     &.icon-ancillary-c-divide {
                        width: 120px !important;
                        height: 140px !important;
                        margin-left: -25px;
                        margin-top: 10px;
                     }
                     &.icon-ancillary-c-reissue {
                        width: 120px !important;
                        height: 105px !important;
                     }
                     &.icon-ancillary-c-seat {
                        width: 100px !important;
                        height: 105px !important;
                        margin-left: -10px;
                     }
                     &.icon-ancillary-c-wheelchair {
                        width: 100px !important;
                        height: 95px !important;
                        margin-left: -20px;
                     }
                     &.icon-ancillary-c-meal {
                        width: 115px !important;
                        height: 120px !important;
                        margin-top: 8px;
                        margin-left: -4px;
                     }
                     &.icon-ancillary-c-sunflex3 {
                        width: 128px !important;
                        height: 124px !important;
                     }
                  }
               }
               .ancillary-box-info-wrapper {
                  .ancillary-title {
                     display: block;
                     width: 100%;
                     text-align: center;
                     font-size: 1.2rem;
                     font-weight: 500;
                     margin-bottom: 1rem;
                  }
                  .ancillary-description {
                     opacity: 0.85;
                     width: 100px;
                  }
                  .ancillary-add-btn-wrapper {
                     display: flex;
                     width: 100%;
                     justify-content: center;

                     button {
                        background-color: var(--gray-800);
                        background-color: var(--orange-400);
                        //color: var(--gray-50);
                        color: var(--gray-0);
                        padding: 0.125rem 1.5rem;
                        border-radius: 8px;
                        font-weight: 600 !important;

                        &:hover {
                           background-color: var(--accent-primary);
                           background-color: var(--gray-800);
                        }
                     }
                  }
               }
            }
         }
      }
   }
}
</style>

<style lang="scss">
#ancillaries-informations {
   border-top: 1px dashed var(--gray-300);
   padding: 1.25rem 0;
   margin-top: 1.25rem;

   text-align: center;
   b {
      font-weight: 600;
   }
}
</style>
